<template>
  <v-flex>
    <v-card color="white" class="rounded">
      <v-card-title class="mb-0">
        <h4 class="subheading">Current Organizations</h4>
        <v-spacer></v-spacer>
        <v-text-field
          v-model="search"
          append-icon="search"
          label="Search"
          single-line
          hide-details
        ></v-text-field>
      </v-card-title>
      <v-card-text>
        <div>
          <v-data-table
            :headers="headers"
            :items="organizations"
            :loading="loading"
            :search="search"
            item-key="subdomain"
            sort-by="name"
            hide-actions
            :pagination.sync="pagination"
            class="elevation-1"
          >
            <template v-slot:progress>
              <v-progress-linear
                color="#d13b55"
                height="2"
                indeterminate
              ></v-progress-linear>
            </template>
            <template v-slot:no-data>
              <v-alert :value="true" outline color="warning" icon="warning"
                >No data to show</v-alert
              >
            </template>
            <template v-slot:items="props">
              <!-- <td>
                <v-icon>mdi-home-city-outline</v-icon>
              </td> -->
              <td>
                <span
                  v-if="props.item.isParentOrg"
                  class="mdi mdi-chevron-right"
                ></span>
                <span
                  v-if="!props.item.isParentOrg"
                  class="mdi mdi-chevron-double-right"
                ></span>
                <span
                  class="font-weight-medium text-uppercase text-main-theme"
                  v-if="isCurrentOrg(props.item.subdomain)"
                  >{{ props.item.name }}
                  <span class="caption text-main-theme mdi mdi-star"></span>
                </span>
                <span class="text-uppercase" v-else>{{ props.item.name }}</span>
              </td>
              <!-- <td class="text-xs-center font-weight-medium">
                {{ props.item.ovationsFund }}
              </td> -->
              <td>
                <span v-if="props.item.isActive">
                  <v-icon title="Active" color="success">mdi-eye-check</v-icon
                  >&nbsp;Active
                </span>
                <span v-if="!props.item.isActive">
                  <v-icon title="Disabled" color="error">mdi-eye-off</v-icon
                  >&nbsp;Disabled
                </span>
              </td>
              <td>
                <v-tooltip
                  bottom
                  v-if="
                    props.item.isActive &&
                    ($store.getters.isSuperAdmin ||
                      $store.getters.isOrgAdmin) &&
                    !isCurrentOrg(props.item.subdomain)
                  "
                >
                  <template v-slot:activator="{ on }">
                    <v-btn
                      v-on="on"
                      icon
                      @click.stop="changeOrgStatus(props.item, 'verify')"
                    >
                      <v-icon color="error">mdi-eye-off</v-icon>
                    </v-btn>
                  </template>
                  <span>Click to Disable</span>
                </v-tooltip>
                <v-tooltip
                  bottom
                  v-if="
                    !props.item.isActive &&
                    ($store.getters.isSuperAdmin || $store.getters.isOrgAdmin)
                  "
                >
                  <template v-slot:activator="{ on }">
                    <v-btn
                      v-on="on"
                      icon
                      @click.stop="changeOrgStatus(props.item, true)"
                    >
                      <v-icon color="success">mdi-eye</v-icon>
                    </v-btn>
                  </template>
                  <span>Click to Enable</span>
                </v-tooltip>

                <span v-if="!isCurrentOrg(props.item.subdomain)">
                  <v-btn icon @click.stop="switchOrg(props.item.subdomain)">
                    <v-icon title="Click to Switch Org" color="primary"
                      >mdi-repeat</v-icon
                    >
                  </v-btn>
                </span>

                <span
                  v-if="
                    ($store.getters.isSuperAdmin ||
                      $store.getters.isOrgAdmin) &&
                    !props.item.isParentOrg &&
                    !isCurrentOrg(props.item.subdomain)
                  "
                >
                  <v-btn icon @click.stop="promptRemoveOrg(props.item)">
                    <v-icon title="Click to Remove Org" color="error"
                      >mdi-trash-can</v-icon
                    >
                  </v-btn>
                </span>
              </td>
            </template>
          </v-data-table>
        </div>
        <div class="text-xs-center pt-2">
          <v-pagination
            color="#d13b55"
            v-model="pagination.page"
            :length="pages"
          ></v-pagination>
        </div>
        <v-flex class="text-xs-right" mt-3 v-if="organizations.length > 0">
          <div>
            <span class="caption"
              ><v-icon>mdi-chevron-right</v-icon> Parent-Org</span
            >
            <span class="caption px-2"
              ><v-icon>mdi-chevron-double-right</v-icon> Sub-Org</span
            >
            <span class="caption"
              ><v-icon color="#d13b55">mdi-star</v-icon> Current-Org</span
            >
            <span class="caption px-2"
              ><v-icon color="success">mdi-eye-check</v-icon> Active</span
            >
            <span
              v-if="$store.getters.isSuperAdmin || $store.getters.isOrgAdmin"
              class="caption"
              ><v-icon color="success">mdi-eye</v-icon> Enable</span
            >
            <span class="caption px-2"
              ><v-icon color="error">mdi-eye-off</v-icon> Disabled
              <!-- <span
                v-if="$store.getters.isSuperAdmin || $store.getters.isOrgAdmin"
                >| Disable Org</span
              > -->
            </span>
            <span class="caption"
              ><v-icon color="primary">mdi-repeat</v-icon> Switch</span
            >
            <span
              v-if="$store.getters.isSuperAdmin || $store.getters.isOrgAdmin"
              class="caption px-2"
              ><v-icon color="error">mdi-trash-can</v-icon> Remove</span
            >
          </div>
        </v-flex>
      </v-card-text>
    </v-card>

    <v-dialog v-model="confirmDisableDialog" overlay persistent max-width="450">
      <v-card>
        <v-card-title class="headline grey lighten-2"
          >Disable Organization</v-card-title
        >
        <v-card-text>
          <p>
            Are you sure you want to disable org
            <span class="red-text">'{{ this.itemToDisable.name }}'</span>?
          </p>
          <p class="caption font-italic">
            Disabling the organization means, Users will not be able to access
            the organization.
          </p>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-btn
            color="secondary"
            class="btn-rounded-medium"
            outline
            @click="confirmDisableDialog = false"
            >Cancel</v-btn
          >
          <v-spacer></v-spacer>
          <v-btn
            class="btn-rounded-medium"
            color="#d13b55"
            outline
            @click="
              changeOrgStatus(itemToDisable, false);
              confirmDisableDialog = false;
            "
            >Disable Organization</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog
      v-model="confirmRemoveOrgDialog"
      overlay
      persistent
      max-width="450"
    >
      <v-card>
        <v-card-title class="headline grey lighten-2"
          >Remove Organization</v-card-title
        >
        <v-card-text>
          <p>
            Are you sure you want to remove org
            <span class="red-text">'{{ this.itemToRemove.name }}'</span>?
          </p>
          <p class="caption font-italic">
            Before removing the org, make sure you have removed all the members
            first. This operation will remove all the data related to org and
            may take a little longer to complete.
          </p>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-btn
            class="btn-rounded-medium"
            color="secondary"
            outline
            @click="confirmRemoveOrgDialog = false"
            >Cancel</v-btn
          >
          <v-spacer></v-spacer>
          <v-btn
            class="btn-rounded-medium"
            color="#d13b55"
            outline
            @click="
              removeOrg(itemToRemove);
              confirmRemoveOrgDialog = false;
            "
            >Remove Organization</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-flex>
</template>

<script>
import axios from "axios";

export default {
  name: "OrganizationsListComponent",
  components: {},
  data() {
    return {
      organizations: [],
      loading: true,
      confirmDisableDialog: false,
      confirmRemoveOrgDialog: false,
      itemToDisable: {},
      itemToRemove: {},
      search: "",
      pagination: {},
      headers: [
        // { text: "", value: "name", sortable: false },
        { text: "Organization Name", value: "name" },
        // { text: "Send Ovations", value: "ovationsFund", width: "120px" },
        { text: "Status", value: "name", sortable: false, width: "140px" },
        {
          text: "Action",
          value: "name",
          sortable: false,
          width: "210px",
          align: "center",
        },
      ],
    };
  },
  computed: {
    pages() {
      if (
        this.pagination.rowsPerPage == null ||
        this.pagination.totalItems == null
      )
        return 0;

      return Math.ceil(
        this.pagination.totalItems / this.pagination.rowsPerPage
      );
    },
  },
  methods: {
    loadOrganizations: function () {
      this.organizations = (this.$store.state.userSelf || {}).orgs || [];
      this.loading = false;
    },
    isCurrentOrg: function (subdomain) {
      return (
        subdomain ==
        ((this.$store.state.userSelf.currentOrg || {}).org || {}).subdomain
      );
    },
    changeOrgStatus: function (org, status) {
      // If disabling an org, verify first
      if (status == "verify") {
        this.itemToDisable = org;
        this.confirmDisableDialog = true;
        return false;
      }

      this.loading = true;

      // Display Message
      const msgMod = status ? "Enabling" : "Disabling";
      this.$store.commit("replaceSnackbar", {
        message: `${msgMod} the "${org.name}" Organization`,
        messageType: "warning",
      });

      const params = { subdomain: org.subdomain, isActive: status };

      axios
        .post("/api/org/status", params, this.$store.state.axiosConfig)
        .then((response) => {
          // Display Success message
          const msgMod = status ? "enabled" : "disabled";
          this.$store.commit("replaceSnackbar", {
            message: `Successfully ${msgMod} the "${org.name}" Organization`,
          });

          // Commit user info to global
          this.$store.commit("setUserSelf", response.data.user);

          // update the list
          this.loadOrganizations();
        })
        .catch((e) => {
          this.loading = false;

          // check/ handle 401 (Unauthorized) error
          this.$store.dispatch("error401Response", e);

          // Display Error Message
          this.$store.commit("replaceSnackbar", {
            message:
              "Error. Organization status was NOT updated.<br><strong>" +
              e.response.data.message +
              "</strong><br>Error #HLI983",
            messageType: "error",
          });
        });
    },
    switchOrg: function (subdomain) {
      if (this.isCurrentOrg(subdomain)) {
        // Display Warning Message
        this.$store.commit("replaceSnackbar", {
          message:
            "Please select a different organization than your current one",
          messageType: "warning",
        });
        return;
      }

      this.loading = true;

      // Display Message
      this.$store.commit("replaceSnackbar", {
        message: "Switching Organization...",
        messageType: "warning",
      });

      const params = { subdomain: subdomain };
      axios
        .post("/api/user/switchorg", params, this.$store.state.axiosConfig)
        .then((response) => {
          this.loading = false;

          // Commit user info to global
          this.$store.commit("setUserSelf", response.data);

          // Display Success message
          this.$store.commit("replaceSnackbar", {
            message: "Organization Switched.",
          });
        })
        .catch((e) => {
          // check/ handle 401 (Unauthorized) error
          this.$store.dispatch("error401Response", e);

          this.loading = false;

          // Display Error Message
          this.$store.commit("replaceSnackbar", {
            message:
              "Error. Organization was NOT switched.<br>Response: " +
              e.response.data.message +
              "<br>Error #NDI832",
            messageType: "error",
          });
        });
    },
    promptRemoveOrg: function (org) {
      this.itemToRemove = org;
      this.confirmRemoveOrgDialog = true;
    },
    removeOrg: function (org) {
      if (!org) return;

      if (this.isCurrentOrg(org.subdomain)) {
        // Display Warning Message
        this.$store.commit("replaceSnackbar", {
          message:
            "Please select a different organization to remove than your current one",
          messageType: "warning",
        });
        return;
      }

      this.loading = true;

      // Display Message
      this.$store.commit("replaceSnackbar", {
        message: "Removing Organization...",
        messageType: "warning",
      });

      const params = { subdomain: org.subdomain };

      axios
        .post("/api/org/remove", params, this.$store.state.axiosConfig)
        .then((response) => {
          // Display Success message
          this.$store.commit("replaceSnackbar", {
            message: "Organization has been removed successfully",
          });

          // Commit user info to global
          this.$store.commit("setUserSelf", response.data.user);

          // update the list
          this.loadOrganizations();
        })
        .catch((e) => {
          this.loading = false;

          // check/ handle 401 (Unauthorized) error
          this.$store.dispatch("error401Response", e);

          // Display Error Message
          this.$store.commit("replaceSnackbar", {
            message:
              "Error. Organization was NOT removed.<br><strong>" +
              e.response.data.message +
              "</strong><br>Error #HLI983",
            messageType: "error",
          });
        });
    },
  },
  watch: {
    // Update the orgs list if new org created
    "$store.state.userSelf.currentOrg.org": function () {
      this.loadOrganizations();
    },
  },
  beforeMount() {
    this.loadOrganizations();
  },
};
</script>
